import { render, staticRenderFns } from "./addTag.vue?vue&type=template&id=1c8a8d24&scoped=true"
import script from "./addTag.vue?vue&type=script&lang=js"
export * from "./addTag.vue?vue&type=script&lang=js"
import style0 from "./addTag.vue?vue&type=style&index=0&id=1c8a8d24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a8d24",
  null
  
)

export default component.exports